import React from "react";
import { CalDate } from "../../../utilities/functions";

const LastReminder = ({ row }) => {
  return <div>{row?.secondReminder ? CalDate(row.secondReminder) : ""}</div>;
};

export default LastReminder;
